module.exports = __webpack_public_path__ + "img/trainingCenter-bg03.59fcda77.png";